import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-search-single-order',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './search-single-order.component.html',
  styleUrl: './search-single-order.component.scss'
})
export class SearchSingleOrderComponent {

  constructor(
    public dialogRef: MatDialogRef<SearchSingleOrderComponent>,
    )
  {}


orderNumber!: number;

onEnter(): void{
  this.dialogRef.close(this.orderNumber);
}

}
